export const createVCInstoreOrder = async (api, order) => {
  const vcinstore_order = await api.post('/api/orders/vc_instore?include=virtual_card_details', { order });
  return vcinstore_order.data.data.attributes;
};
